/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import "@infragistics/igniteui-react-grids/grids";
import "@infragistics/igniteui-react-grids/grids/combined";
import "@infragistics/igniteui-react-grids/grids/themes/light/bootstrap.css";
import {
    IgrColumn,
  IgrGrid,
  IgrGridModule,
  IgrGridState,
} from "@infragistics/igniteui-react-grids";
import { mobileMode } from "../../../Resources/content";
import _ from "lodash";
import { gridLayoutLoad } from "./grid-functions";
import "./grid.scss";
import { useSelector } from "react-redux";
import { GetSystemSettings } from "../../../Services/LocalStorageService";
import { handleTimeZone } from "../../../Services/DateForamt";
// Register the required modules
const mods = [IgrGridModule];
mods.forEach((m) => m.register());

// Check if the device is in mobile mode
const isMobile = mobileMode();

/**
 * InfraGrid component
 *
 * @param {Object} props - Component props
 * @param {Array} props.data - Data to be displayed in the grid
 * @param {boolean} props.isLoading - Indicates if the data is being loaded
 * @param {Function} props.onGridRef - Callback function to get the grid reference
 * @param {string} [props.gridWidth] - Width of the grid
 * @param {string} [props.gridHeight] - Height of the grid
 * @param {string} props.gridPrimaryKey - Primary key for the grid data
 * @param {boolean} [props.autoGenerate] - Indicates if columns should be auto-generated
 * @param {boolean} [props.allowFiltering] - Indicates if filtering is allowed
 * @param {string} [props.filterMode] - Filter mode for the grid ExcelStyleFilter/QuickFilter
 * @param {boolean} [props.moving] - Indicates if columns can be moved
 * @param {string} [props.rowSelection] - Row selection mode
 * @param {string} [props.gridClassName] - CSS classes for the grid
 * @param {Function} props.getSelectedItems - Callback function to get the grid reference
 * @returns {JSX.Element} - Rendered InfraGrid component
 */
function InfraGrid({
  data,
  isLoading,
  onGridRef=null,
  onGridStateRef=null,
  gridWidth = "100%",
  gridHeight = `calc(100% - ${isMobile ? "4%" : "2%"})`,
  gridPrimaryKey="",
  autoGenerate = false,
  allowFiltering = true,
  filterMode = "ExcelStyleFilter",
  moving = true,
  rowSelection = "Multiple",
  gridClassName = "",
  gridColumns=[],
  customRenderedColumns=[],
  getSelectedItems=null,
  rowStyles=null,
  rowClasses=null,
  selectRowOnClick=true,
  activeTab={},
  previewLayout=[],
  className="grid-height",
  enablePresentPageSelected=true,
  parentSelectedIds=[],
  isEmptySelected=false,
  isCheckboxDisabled=null,
  ...props
}) {
    const [gridData, setGridData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [firstEffectCompleted, setFirstEffectCompleted] = useState(false);
    const [getpresentPageSelected, setGetPresentPageSelected] = useState([])
    const [selectedItems, setSelectedItems] = useState([]);
    const [SelectedData, setSelectedData] = useState();
    const darkMode = useSelector((state) => state.darkMode);
    // Reference to the grid component
    let gridRef = useRef(null);
    // Reference to the grid state component
    let gridStateRef = useRef(null);
    /**
 * Converts a date format string from uppercase to the desired format.
 * Only 'DD' will be converted to 'dd', the rest remain in uppercase.
 * @param {string} formatString - The date format string to be converted.
 * @returns {string} - The converted date format string.
 */
    const convertFormatString = (formatString) => {
      return formatString.replace(/DD/, 'dd');
    };
    const userSettingsData = GetSystemSettings() ||{};
    let date_format='MM/DD/YYYY';
    const dateformat = convertFormatString(userSettingsData?.date_format || date_format);
    const timeZoneFormat = userSettingsData?.time_format === "12 Hours AM/PM" ? "hh:mm:ss a" : "HH:mm:ss"
    let time_zone=localStorage.getItem('defaultTimeZone');
    if(userSettingsData?.time_zone){
      time_zone=userSettingsData.time_zone;
    }
    if(Object.keys(userSettingsData).length !== 0 && userSettingsData.time_zone){
     time_zone = handleTimeZone(time_zone);
    }
  useEffect(() => {
    if (parentSelectedIds.length > 0) {
      setTotalSelectedIds(prevTotal => {
        // Combine previous total with new parentSelectedIds, removing duplicates
        return [...new Set([...parentSelectedIds])];
      });
    
      setSelectedItems(prev => {
        // Create a map of gridData for faster lookups
        const gridDataMap = _.keyBy(gridData, gridPrimaryKey);
    
        // Combine previous items with new parentSelectedIds
        const combinedIds = [...new Set([ ...parentSelectedIds])];
    
        // Map combined IDs to items, using gridData if available, or creating placeholders
        return combinedIds.map(id => 
          gridDataMap[id] || 
          prev.find(item => item[gridPrimaryKey] === id) || 
          { [gridPrimaryKey]: id, isPlaceholder: true }
        );
      });
    }  }, [parentSelectedIds, gridData]);

  useEffect(() => {
    if (isEmptySelected) {
      setTotalSelectedIds([]);
      setGetPresentPageSelected([]);
      setSelectedItems([]);
    }
  }, [isEmptySelected])

  useEffect(()=> {
    if(enablePresentPageSelected){

      const presentPageSelectedItems = _.chain(gridData)
    .map(gridPrimaryKey)
    .filter(value => _.includes(totalSelectedIds, value))
    .value();
    setGetPresentPageSelected(presentPageSelectedItems);
    }
  }, [totalSelectedIds, gridData])

  useEffect(() => {
    if(getSelectedItems){

      getSelectedItems(selectedItems);
    }
  }, [SelectedData])


  useEffect(()=>{
    if (!_.isEqual(SelectedData, selectedItems)){
      setSelectedData(selectedItems)
    }
  },[selectedItems])

  useEffect(() => {
    if (!data) return;
    let columnsLocal = gridColumns?.map((column) => {
      let formatOptions = {}

      if (column.dataType === "Date") {
        formatOptions = {
          format: `${dateformat}`
        };  
      } else if (column.dataType === "DateTime") {
        formatOptions = {
          format: `${dateformat} ${timeZoneFormat}`,
          timezone: time_zone
        };
      } else if (column?.decimal) {
        formatOptions = {
          currencyCode: "",
          digitsInfo: "1.0-2"
        };
      }
    
      return (
        <IgrColumn
          key={column.name}
          field={column?.field || column?.name}
          header={column.name}
          headerText={column.name}
          autosizeHeader={true}
          minWidth={column.minWidth}
          headerClasses=''
          dataType={column.dataType}
          width={column.width}
          sortable={column?.sortable || "true"}
          {...(column?.groupable && {groupable : column?.groupable})}
          {...(column?.disableHiding && {disableHiding : column?.disableHiding})}
          filterable={column?.filterable || "true"}
          resizable="true"
          {...(customRenderedColumns?.includes(column.name) && { bodyTemplate: column?.bodyTemplate })}
          name={column.name}
          {...((column.dataType === "Date" || column.dataType === "DateTime" || column?.decimal) && { pipeArgs: formatOptions })}
        />
      );
    });

    if (data.length > 0) {
      setColumns(columnsLocal);
    }
    setGridData(data);
    if(getpresentPageSelected){
      setGetPresentPageSelected([]);
    }
    setFirstEffectCompleted(true);
  }, [data]);

  useEffect(() => {
    if (activeTab?.viewDetails && gridStateRef && gridRef && gridData.length > 0 && firstEffectCompleted) {
      setTimeout(()=>{
        gridLayoutLoad(activeTab, gridRef, gridStateRef);
      },50)
    }
  }, [activeTab, gridData, firstEffectCompleted]);

  // useEffect(()=> {
  //   if (previewLayout?.viewDetails && gridStateRef && gridRef) {
  //     gridLayoutLoad(previewLayout, gridRef, gridStateRef);
  //   }
  // }, [previewLayout])


  // Callback function to get the grid state reference
  function onIgrGridStateRef(ref) {
    gridStateRef.current = ref;
    onGridStateRef && onGridStateRef(ref);
  }

  const onIgrGridRef = (ref) => {
    gridRef.current = ref;
    onGridRef && onGridRef(ref);
  }


  const rowSelectionChanging = (args, evt) => {
    const detail = evt.detail;
    const isSelectAllAction = detail?.allRowsSelected;
    const gridViewData = args?.dataView;
   
    const isItemDisabled = (item) => typeof isCheckboxDisabled === 'function' ? isCheckboxDisabled(item) : false;
  
    // Get current page IDs
    const currentPageIds = new Set(gridViewData.map(item => item[gridPrimaryKey]));
    
    // Create Map of selected items for faster lookup
    const selectedItemsMap = new Map(selectedItems.map(item => [item[gridPrimaryKey], item]));
  
    let newSelection;
  
    if (isSelectAllAction) {
      // Optimize select all action
      const selectableItems = gridViewData.filter(item => !isItemDisabled(item));
      const allSelectableSelected = selectableItems.every(item => selectedItemsMap.has(item[gridPrimaryKey]));
  
      if (allSelectableSelected) {
        newSelection = new Set(selectedItems.filter(item => !currentPageIds.has(item[gridPrimaryKey]) || isItemDisabled(item)));
      } else {
        newSelection = new Set([
          ...selectedItems.filter(item => !currentPageIds.has(item[gridPrimaryKey])),
          ...selectableItems,
          ...selectedItems.filter(item => currentPageIds.has(item[gridPrimaryKey]) && isItemDisabled(item))
        ]);
      }
    } else {
      // Optimize individual selection
      const currentPageSelection = new Set(detail.newSelection.filter(item => !isItemDisabled(item)));
      newSelection = new Set([
        ...selectedItems.filter(item => !currentPageIds.has(item[gridPrimaryKey])),
        ...currentPageSelection,
        ...selectedItems.filter(item => currentPageIds.has(item[gridPrimaryKey]) && isItemDisabled(item))
      ]);
    }
  
    // Convert Set back to array and update state
    const newSelectionArray = Array.from(newSelection);
    setSelectedItems(newSelectionArray);
  
    const selectedIds = newSelectionArray.map(item => item[gridPrimaryKey]);
    setTotalSelectedIds(selectedIds);
  
    detail.newSelection = newSelectionArray.filter(item => currentPageIds.has(item[gridPrimaryKey]));
  };
   

  function handleGridKeydown(grid, args) {
    const target = args.detail.event.target;
  
    if (target.tagName.toLowerCase() === 'input' || target.tagName.toLowerCase() === 'igc-input') {
      args.detail.cancel = true;
    }
  }
  return (
    <div {...props} className={`${className} grid-class ${darkMode ? "grid-dark-mode" : ""}`}>
      <IgrGrid
        key={`grid-${activeTab?.viewDetails}-${activeTab?.name}-${data?.length}`}
        width={gridWidth}
        height={gridHeight}
        data={gridData}
        {...(gridPrimaryKey && { primaryKey: gridPrimaryKey })}
        autoGenerate={autoGenerate}
        displayDensity="Compact"
        allowFiltering={allowFiltering}
        filterMode={filterMode}
        moving={moving}
        rowSelection={rowSelection}
        isLoading={isLoading}
        className={gridClassName}
        ref={onIgrGridRef}
        rowSelectionChanging={rowSelectionChanging}
        selectedRows={enablePresentPageSelected ? getpresentPageSelected : totalSelectedIds}
        {...(rowClasses && { rowClasses: rowClasses })}
        {...(rowStyles && { rowStyles: rowStyles })}
        selectRowOnClick={selectRowOnClick}
        gridKeydown={handleGridKeydown}
        emptyGridMessage="No Data Found"
        // cellClick={cellClick}
      >
        <IgrGridState ref={onIgrGridStateRef}></IgrGridState>
        {/* Additional columns can be added here */}
        {columns}
      </IgrGrid>
    </div>
  );
}

export default InfraGrid;
